// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./dist/chunks/" + ({"334":"leaflet","595":"star-rating"}[chunkId] || chunkId) + "." + {"334":"7355b853","595":"3bf89b32","748":"bf730553"}[chunkId] + ".js";
};